import React from 'react'

import { Box, Button, Link, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { SpendingPolicyData } from 'modules/expenses/graphql/types'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import { amountWithCurrency } from 'modules/finance/lib/budgets'

interface Props {
  policy: SpendingPolicyData
}

export const PolicyStatusCardContent = ({ policy }: Props) => {
  const { navigation } = useNavigation()
  const {
    access: { locale },
  } = useCurrentSession()

  const { navigation: expensesNavigation } = useExpensesNavigation()

  const policyExceeded = policy.result === 'out_of_policy'
  const searchParams = new URLSearchParams()
  const amount = Number(policy.amount?.formatedValue)
  const currency = policy.currency?.formatedValue
  const category = policy.category?.formatedValue
  const subcategory = policy.subcategory?.formatedValue
  const timeframe = policy.timeframe?.formatedValue?.toLowerCase()
  const spentAmount = Number(policy.spentAmount)

  const formattedAmount = currency ? amountWithCurrency(amount, currency, locale) : ''
  const formattedTotal = currency ? amountWithCurrency(spentAmount, currency, locale) : ''
  const formattedOverspent = currency
    ? amountWithCurrency(spentAmount - amount, currency, locale)
    : ''

  const expensesUrl = `${expensesNavigation.list.fullPath()}?${searchParams.toString()}`

  const InterpolatedText = (text?: string | null) => (
    <span className="text-200 font-semibold">{text}</span>
  )

  return (
    <Box gap="s24" paddingX="s8" paddingBottom="s8">
      <Box gap="s8">
        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="200" weight="semibold" color="grey1000">
            {policy.name}
          </Text>
          <Link.Router external to={navigation.expenses.spendingPolicies.list.fullPath()}>
            {i18n.t('common.view')}
          </Link.Router>
        </Box>
        <Box maxWidth="s400" gap="s16">
          <Text size="200">
            {subcategory
              ? i18n.tView('budgets.forms.external_resource.spending_policy.info_subcategory', {
                  subcategory: InterpolatedText(subcategory),
                  category: InterpolatedText(category),
                  amount: InterpolatedText(formattedAmount),
                  timeframe: InterpolatedText(timeframe),
                })
              : i18n.tView('budgets.forms.external_resource.spending_policy.info_category', {
                  category: InterpolatedText(category),
                  amount: InterpolatedText(formattedAmount),
                  timeframe: InterpolatedText(timeframe),
                })}
          </Text>
          {policyExceeded && (
            <Box width="s300" flexDirection="row" justifyContent="spaceBetween">
              <Text size="200">
                {i18n.tView('budgets.forms.external_resource.spending_policy.total_spent', {
                  amount: InterpolatedText(formattedTotal),
                })}
              </Text>
              <Text size="200">
                {i18n.tView('budgets.forms.external_resource.spending_policy.overspent', {
                  amount: InterpolatedText(formattedOverspent),
                })}
              </Text>
            </Box>
          )}
        </Box>
      </Box>
      <Button.Router iconName="expenses" type="secondary" to={expensesUrl} blankTarget>
        {i18n.t('budgets.forms.external_resource.spending_policy.view_expenses')}
      </Button.Router>
    </Box>
  )
}
